import { getPromiseState } from '@warp-drive/ember';
import Icon from './icon.gjs';
import { faTriangleExclamation } from '../icons/solid.js';

<template>
  {{#if @promise}}
    <div class="flex items-center px-4">
      {{#let (getPromiseState @promise) as |p|}}
        {{#if p.isPending}}
          <span class="loading loading-bars loading-sm w-6 h-6 text-primary" />
        {{else if p.isError}}
          <span
            class="tooltip tooltip-bottom tooltip-error"
            data-tip={{p.error.message}}
          >
            <Icon @icon={{faTriangleExclamation}} @class="w-6 h-6 text-error" />
          </span>
        {{/if}}
      {{/let}}
    </div>
  {{/if}}
</template>
